import React, { useState } from 'react';
import { FiFilter } from 'react-icons/fi';
import UserIdPopup from '../models/UserIdPopup';

const FilterBar = ({ selectedOption, setUserIdFilters }) => {
  const [userIdPopup, setUserIdPopup] = useState(false);

  return (
    <>
      <div className="mt-2 relative">
        <div className="flex items-center h-8 bg-[#2c9688] px-3 text-white font-sans rounded-lg border-2 border-[#000000] shadow-sm">
          <div className="w-full flex justify-between items-center">
            <span className="font-bold text-sm tracking-wide">All</span>
            <div className="flex items-center justify-center gap-5">
              <button
                onClick={() => setUserIdPopup(true)}
                className="flex items-center gap-1 hover:opacity-80 transition-opacity font-semibold text-xs cursor-pointer"
                aria-label="Filter options"
              >
                <FiFilter className="text-sm" />
                <span>Filter</span>
              </button>
            </div>
          </div>
        </div>

        {userIdPopup && <UserIdPopup onClose={() => setUserIdPopup(false)} setFilters={setUserIdFilters} />}
      </div>
    </>
  );
};

export default FilterBar;